module.exports = __webpack_public_path__ + "static/media/yt.a3c5c1d5.svg";